<template>
  <div class="content-title">
  <span class="title-kh-1">》</span><span class="title-kh-2">》</span><span>{{title}}</span>
  </div>
</template>

<script>
  export default {
    props: ['title']
  }
</script>

<style scoped lang="less">
  @import '../style/base.less';
  .content-title {
    font-size: 1.13em;
    color: @line-color;
    color: rgba(255, 255, 255, 1);
    height: 2.5em;
    min-height: 2.5em;
    background-color: #0b5591;
    display: flex;
    border-top-left-radius: @content-border-radius-size;
    border-top-right-radius: @content-border-radius-size;
    align-items: center;
    justify-content: flex-start;
    padding-left: 2.5em;
    .title-kh-1 {
      color: rgba(255, 255, 255, 0.5);
      letter-spacing: -0.71em;
    }
    .title-kh-2 {
      color: rgba(255, 255, 255, 1);
      letter-spacing: -2px;
    }
    i {
      padding-right: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// ContentTitle.vue?1c2e09ba